import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import FlexibleDataOptimized from '@lib/cms/flexibleDataOptimized';

// ---------------------------------------------------------

export async function getStaticProps(context) {
  const preview = context.preview || false;
  const previewEnv = context?.previewData?.environment ?? null;
  const pageData = await FlexibleDataOptimized.fetchTopicPage(
    'HomeServices',
    'home-services',
    preview,
    previewEnv
  );

  return {
    props: { pageData, preview }
  };
}

// ---------------------------------------------------------

const Home = ({ pageData, preview }) => {
  return (
    <TopicPageTemplate
      collection="HomeServices"
      coreService
      pageData={pageData}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
